import {
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  styled,
  useTheme,
} from "@mui/material";
import { useContext, useState } from "react";
import { Button, Typography } from "@platform/design-system";
import { RFP_ACTION_VALUES } from "@platform/rfp-core";

import { RfpContext } from "../../../contexts";

const UploadedDocs = ({
  isOpen,
  onCancel,
  onSaveDocuments,
  externalFiles,
  uploadedFiles,
  documentTypeName,
  setExternalFiles,
  initialExternals,
}) => (
  <Dialog fullWidth maxWidth="sm" open={isOpen} onClose={onCancel}>
    <UploadedDocsBody
      onCancel={onCancel}
      onSaveDocuments={onSaveDocuments}
      externalFiles={externalFiles}
      uploadedFiles={uploadedFiles}
      documentTypeName={documentTypeName}
      setExternalFiles={setExternalFiles}
      initialExternals={initialExternals}
    />
  </Dialog>
);

export const UploadedDocsBody = ({
  onCancel,
  onSaveDocuments,
  externalFiles,
  uploadedFiles,
  documentTypeName,
  setExternalFiles,
  initialExternals,
}) => {
  useTheme();
  const { ADDITIONAL_DOCUMENTS } = RFP_ACTION_VALUES;

  const [localExternalFiles, setLocalExternalFiles] = useState(externalFiles);
  const { rfp } = useContext(RfpContext);
  const AdditionalDocuments = rfp[ADDITIONAL_DOCUMENTS] || [];

  let filterUploadedFiles = [...uploadedFiles];
  const additionalFiles = AdditionalDocuments;

  additionalFiles?.forEach((file) => {
    filterUploadedFiles =
      uploadedFiles?.filter((d) => d.fileName !== file) || [];
  });

  const filterOutInitials = (arr, arrField) =>
    arr.filter(
      (item) =>
        !initialExternals.find((initial) => initial.name === item[arrField]),
    );

  const allChecked =
    filterOutInitials(filterUploadedFiles, "fileName").length ===
    filterOutInitials(localExternalFiles, "name").length;

  const onToggleSelection = (type, file) => {
    if (type === "all") {
      setLocalExternalFiles(
        allChecked
          ? initialExternals
          : filterUploadedFiles.map((item) => item.file),
      );
    } else {
      const existFile = localExternalFiles.find(
        (item) => item.name === file.name,
      );
      setLocalExternalFiles((prev) =>
        existFile
          ? prev.filter((item) => item.name !== file.name)
          : [...prev, file],
      );
    }
  };

  const onCancelUpload = () => {
    setExternalFiles(externalFiles);
    onCancel();
  };

  const onSaveUpload = () => {
    setExternalFiles(localExternalFiles);
    onSaveDocuments(localExternalFiles);
  };

  const allCheckedAndDisabled = () => {
    let isAllChecked = true;
    filterUploadedFiles.forEach((item) => {
      if (!isChecked(item)) {
        isAllChecked = false;
      }

      if (!item.documentTypes[documentTypeName]) {
        isAllChecked = false;
      }
    });

    return isAllChecked;
  };

  const isChecked = (fileItem) => {
    const fileDocumentTypes = Object.keys(fileItem?.documentTypes || {});
    const fileNameExist = localExternalFiles.find(
      (item) => item.name === fileItem.fileName,
    );
    if (fileDocumentTypes.includes(documentTypeName) || fileNameExist) {
      return true;
    }

    return false;
  };
  return (
    <>
      <DialogTitle>Select Uploaded Documents</DialogTitle>
      <DialogContent>
        <>
          <Typography variant="body-large">
            Select from the list of uploaded documents the ones that apply for{" "}
            <b>{documentTypeName}</b> below—
          </Typography>
          <Box display="flex" flexDirection="column" mb={3}>
            <StyledFormControlLabel
              control={
                <Checkbox
                  checked={allChecked}
                  disabled={allCheckedAndDisabled()}
                  onChange={() => onToggleSelection("all")}
                />
              }
              label={
                <Typography variant="body-medium">
                  <strong>Select all</strong>
                </Typography>
              }
            />
            {filterUploadedFiles.map((uploadedFile) => (
              <StyledFormControlLabel
                key={uploadedFile.fileName || "N/A"}
                control={
                  <Checkbox
                    checked={isChecked(uploadedFile)}
                    disabled={!!uploadedFile.documentTypes[documentTypeName]}
                    onChange={() =>
                      onToggleSelection("single", uploadedFile.file)
                    }
                    value={uploadedFile}
                  />
                }
                label={uploadedFile.fileName}
              />
            ))}
          </Box>
        </>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelUpload} variant="tertiary">
          Cancel
        </Button>
        <Button onClick={onSaveUpload} variant="primary">
          Save
        </Button>
      </DialogActions>
    </>
  );
};

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  padding: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.neutrals.neutral_300}`,
  wordBreak: "break-all",
}));

export default UploadedDocs;
